module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#gallery",
      toString: function () {
        return this.url;
      }
    }